import React from "react";

export default function CalibrationPlaceIcon({
  place,
  className = "",
  titleText = "",
}) {
  const isInSitu = String(place || "").trim().toLowerCase() === "in situ";
  const title = isInSitu ? "Calibrado in situ" : "Laboratorio";
  const ariaLabel = titleText || title;
  const tone = isInSitu
    ? "border-amber-500/40 bg-amber-500/10 text-amber-300"
    : "border-emerald-500/40 bg-emerald-500/10 text-emerald-300";
  const label = isInSitu ? "in situ" : "lab";

  return (
    <span
      title={titleText || title}
      aria-label={ariaLabel}
      className={`inline-flex h-5 min-w-9 items-center justify-center rounded-full border px-1.5 text-[10px] font-medium leading-none uppercase tracking-wide align-middle ${tone} ${className}`}
    >
      {label}
    </span>
  );
}
